export const decimalToPercents = (decimal: number | string): number => Number(decimal) * 100;

export const percentsToDecimal = (percents: number | string): number => Number(percents) / 100;
